module.exports = __webpack_public_path__ + "static/scan-to-preview-c51baad68ab309cb0def05c5d9d902e1.jpg";